import httpService from "..";

export const searchMemberTransactionsApi = async (memberId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/member/${memberId}/transactions/search?search=${search}`,
    "get"
  );
};

export const addTransactionApi = async (policyId: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction?policyId=${policyId}`,
    "post",
    data
  );
};

export const removeTransactionApi = async (id: any, policyId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/${id}?policyId=${policyId}`,
    "delete",
    {}
  );
};

export const getMemberTransactionsApi = async (memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/member/${memberId}/transactions`,
    "get"
  );
};

export const addAdjustmentApi = async (policyId: string, data: { amount: number; note: string; userId: number }) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/adjustment?policyId=${policyId}`,
    "post",
    data
  );
};

export const getTransactionsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction`,
    "get"
  );
};

export const getTransactionApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/${id}`,
    "get"
  );
};

export const getPolicyTransactionsApi = async (policyId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/policy/${policyId}`,
    "get"
  );
};

export const editTransactionApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/transaction/${id}`,
    "patch",
    data
  );
};
